import * as React from 'react';
import styled from '@emotion/styled';
import CarruselFONE from './CarruselFONE';
import { motion } from "framer-motion";
import logoFONE from "../assets/logos/FONE_LOGO_02.png";

const Calendar = ({ setPageType, pageType }) => {
  const NewsDiv = styled.div`
    background: #ededed;
    padding-bottom: 50px;
  `;

  const Descripcion = styled.p`
    font-family: "DM Sans", serif;
    font-size: 15px;
    color: black;
    padding: 20px;
    width: 80%;
    margin: auto;
  `;

  const Logo = styled(motion.img)`
    height: 80px;
    margin: 20px;
    margin-top: 40px;

    @media (max-width: 1024px) {
      height: 60px;
    }

    @media (max-width: 768px) {
      height: 50px;
    }

    @media (max-width: 480px) {
      height: 40px;
    }
  `;

  return (
    <NewsDiv>
      <Logo
        src={logoFONE}
        alt="Logo Capa"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        viewport={{ once: true }}
      />
      <Descripcion>
        La Formación Nacional de Especialidades de Cruz Roja Mexicana <strong>FONE</strong>, se centra en las capacitaciones prácticas y específicas que responden a las necesidades operativas y de emergencia, con un enfoque que permita una mayor flexibilidad y actuación eficaz a situaciones reales, proporcionando a los participantes las habilidades y los conocimientos necesarios que se requieren para su desempeño en el campo.
        <br /><br /><strong>¡Consulta nuestro calendario!</strong>
      </Descripcion>
      <CarruselFONE />
    </NewsDiv>
  );
};

export default Calendar;

